module.exports = __webpack_public_path__ + "img/ewm.f551c1a8.jpg";